import ProxyBase from '../../../../core/proxies/ProxyBase'

class NotificationsProxy extends ProxyBase {
  getUserNotificationSettings(params) {
    return this.get('UserNotificationSettings', params)
  }

  postUserNotificationSettings(params) {
    return this.post('UserNotificationSettings', params)
  }

  getUnreadCount(params) {
    return this.get('UnreadCount', params)
  }

  getPaged(params) {
    return this.get('Paged', params)
  }

  updateReadStatus(params) {
    return this.post('UpdateReadStatus', params)
  }

  postMarkAllAsRead(params) {
    return this.post('MarkAllAsRead', params)
  }

  deleteNotifications(params) {
    return this.delete('Notifications', params)
  }
}

export default new NotificationsProxy('Notification/')
